import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

var log = require('loglevel').getLogger('react-ui/hoc/list-normalizer');
/**
  * @module list-normalizer
  */

/**
 * @typedef {function} ComponentWithTransformedList - a new component which can transform list (defined by *listPropName*) according to config (defined by *transformPropName*)
 * @property {array.<object>} [*listPropName*] - list to apply transformation to
 * @property {object} [*transformPropName*] - key/value pair, key=name to pass onto Component, value=name to take
 */

/**
 * Normalize list in Component
 * @param {component} Component - which component to apply transformation to?
 * @param {string} [listPropName='list'] - name of the Component prop which will be the target to apply transformation to
 * @param {string} [transformPropName='listTransform'] - name of the transformation config
 * @return {ComponentWithTransformedList} transformd component
 *
 * @example
// See [example]{@link https://git.gorilla-technology.com/gorilla/react-ui/blob/master/examples/src/form.js}
 */


export function transform(Component) {
  var _class, _temp, _defineProperty2;

  var listPropName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'list';
  var transformPropName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'listTransform';
  return _temp = _class = /*#__PURE__*/function (_React$Component) {
    _inherits(_class, _React$Component);

    var _super = _createSuper(_class);

    function _class() {
      _classCallCheck(this, _class);

      return _super.apply(this, arguments);
    }

    _createClass(_class, [{
      key: "render",
      value: function render() {
        var _this = this,
            _objectSpread2;

        var _this$props = this.props,
            transformCfg = _this$props[transformPropName],
            listToTransform = _this$props[listPropName];

        if (!transformCfg) {
          return /*#__PURE__*/React.createElement(Component, _objectSpread(_objectSpread({}, this.props), {}, {
            ref: function ref(_ref) {
              _this._component = _ref;
            }
          }));
        }

        return /*#__PURE__*/React.createElement(Component, _objectSpread(_objectSpread({}, _.omit(this.props, transformPropName)), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, listPropName, _.map(listToTransform, function (item) {
          return _.mapKeys(item, function (v, k) {
            return _.get(_.invert(transformCfg), k);
          });
        })), _defineProperty(_objectSpread2, "ref", function ref(_ref2) {
          _this._component = _ref2;
        }), _objectSpread2)));
      }
    }]);

    return _class;
  }(React.Component), _defineProperty(_class, "propTypes", (_defineProperty2 = {}, _defineProperty(_defineProperty2, transformPropName, PropTypes.object), _defineProperty(_defineProperty2, listPropName, PropTypes.array), _defineProperty2)), _temp;
}
export default transform;